import { IUpdateOrdemCompraUseCase } from "../../../presentation/useCases/update/update_ordem_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateOrdemCompraUseCase
 */

export class UpdateOrdemCompraUseCase implements IUpdateOrdemCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateOrdemCompra(
    idOrdemCompra: number,
    idInformacaoFaturamento: number | null | undefined,
    idCentroCustoEndereco: number | null | undefined,
    dataRef: Date | undefined,
    entrega: number,
    responsavelDescarga: number,
    informacaoGeral: string | undefined,
    observacao: string | undefined,
    rua: string | undefined,
    numero: string | undefined,
    complemento: string | undefined,
    cep: string | undefined,
    estado: string | undefined,
    cidade: string | undefined,
    bairro: string | undefined,
    pais: string | undefined,
    nomeBanco: string | undefined,
    tipoConta: number | undefined,
    nrConta: string | undefined,
    digito: string | undefined,
    agencia: string | undefined,
    operacao: string | undefined,
    favorecido: string | undefined,
    cpfCnpj: string | undefined,
    pix: string | undefined,
  ): Promise<void> {
    await this.repository.updateOrdemCompra(
      idOrdemCompra,
      idInformacaoFaturamento ?? null,
      idCentroCustoEndereco ?? null,
      dataRef ?? null,
      entrega,
      responsavelDescarga,
      informacaoGeral ?? null,
      observacao ?? null,
      rua ?? null,
      numero ?? null,
      complemento ?? null,
      cep ?? null,
      estado ?? null,
      cidade ?? null,
      bairro ?? null,
      pais ?? null,
      nomeBanco ?? null,
      tipoConta ?? null,
      nrConta ?? null,
      digito ?? null,
      agencia ?? null,
      operacao ?? null,
      favorecido ?? null,
      cpfCnpj ?? null,
      pix ?? null,
    );
  }
}
